import { request } from '../utils/request';

export const saveMigrationConfig = data =>
  request.put('/superadmin/hub-custom-field-config/migration', data);

export const triggerMigration = data =>
  request.post('/superadmin/hub-custom-field-config/migration', data);
